// extracted by mini-css-extract-plugin
export var childrenContainer = "_4l-0";
export var virtualScrollArea = "_4l-1";